import { render, staticRenderFns } from "./AddProviderIcon.vue?vue&type=template&id=c3a24682"
import script from "./AddProviderIcon.vue?vue&type=script&lang=js"
export * from "./AddProviderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports